import { useState } from 'react';

export const INITIAL_UI_STATE: Readonly<IMenuState> = {
  activeMenuIndex: -1,
  isMenuDrawerOpen: false,
};

interface IMenuState {
  // The index of the main menu item that is "active"
  activeMenuIndex: number;
  // Condition if narrow drawer is open (For browser width is mobile or tablet)
  isMenuDrawerOpen: boolean;
}

export interface IUiController extends IMenuState {
  // Condition if any drawer is open
  isDrawerOpen: boolean;
  // Condition if wide drawer is open (For browser width is desktop or desktop+)
  isSubNavDrawerOpen: boolean;
  openSubNavDrawer: (activeMenuIndex: number) => void;
  closeDrawer: () => void;
  closeMenuDrawer: () => void;
  closeSubNavDrawer: () => void;
  openMenuDrawer: () => void;
}

export function useUiController(): IUiController {
  const [{ activeMenuIndex, isMenuDrawerOpen }, setMenuState] = useState<IMenuState>(INITIAL_UI_STATE);

  const isSubNavDrawerOpen = activeMenuIndex > INITIAL_UI_STATE.activeMenuIndex;
  const isDrawerOpen = isSubNavDrawerOpen || isMenuDrawerOpen;

  const closeDrawer = () =>
    setMenuState(prev => ({
      ...prev,
      activeMenuIndex: INITIAL_UI_STATE.activeMenuIndex,
      isMenuDrawerOpen: false,
    }));
  const closeMenuDrawer = () => setMenuState(prev => ({ ...prev, isMenuDrawerOpen: false }));
  const openSubNavDrawer = (activeMenuIndex: number) => setMenuState(prev => ({ ...prev, activeMenuIndex }));
  const closeSubNavDrawer = () => setMenuState(prev => ({ ...prev, activeMenuIndex: -1 }));
  const openMenuDrawer = () => setMenuState(prev => ({ ...prev, isMenuDrawerOpen: true }));

  return {
    activeMenuIndex,
    isDrawerOpen,
    isMenuDrawerOpen,
    isSubNavDrawerOpen,
    closeDrawer,
    closeMenuDrawer,
    closeSubNavDrawer,
    openMenuDrawer,
    openSubNavDrawer,
  };
}
